import { RootState } from '@Store/index';
import {
  getSalaryStatusesDictSelector,
  getSalaryTypeDictSelector,
} from '@Store/selectors/dictionarySelector';
import { prepareRequisitionInfo } from '@Utils/requisitionInfo';
import { createSelector } from '@reduxjs/toolkit';
import { transformDictToOptions } from '@Utils/transformToOptions';
import { salaryTypeOptionsAllowed } from './salaryTypeOptionsAllowed';

const salaryCertificate = (state: RootState) =>
  state.featureStores.salaryCertificate;

export const currentSalaryCertificate = createSelector(
  salaryCertificate,
  ({ salaryCertificate }) => salaryCertificate
);

export const salaryCertificateCreateRequisitionInfo = createSelector(
  [currentSalaryCertificate, getSalaryStatusesDictSelector],
  (salaryCertificate, salaryStatuses) => {
    const requisitionInfo = prepareRequisitionInfo(
      salaryCertificate,
      salaryStatuses
    );
    return requisitionInfo;
  }
);

export const getSalaryCertificateTypeOptions = createSelector(
  getSalaryTypeDictSelector,
  (salaryTypeDict) => {
    const salaryTypeDictFiltered = salaryTypeDict.filter(
      (salaryTypeItem) => salaryTypeOptionsAllowed[salaryTypeItem.codeNum]
    );

    const salaryTypeOptions = transformDictToOptions(salaryTypeDictFiltered);
    return salaryTypeOptions;
  }
);

export const getSalaryCertTypeLabels = createSelector(
  getSalaryCertificateTypeOptions,
  (typeOptions) => typeOptions.map((typeOption) => typeOption.label)
);

export const getStatusLabels = createSelector(
  getSalaryStatusesDictSelector,
  (statuses) => statuses.map((status) => status.codeDesc)
);
